function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyberhawkTextBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 659.42771 47.0098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.24947,66.8021a16.47064,16.47064,0,0,1-11.8125-4.8106c-4.3506-4.3486-4.3506-8.8916-4.3506-18.6963,0-9.8076,0-14.3496,4.3506-18.6982a16.46128,16.46128,0,0,1,11.8125-4.8047c8.3096,0,14.4795,5.0625,16.0401,13.7637h-5.0645c-1.2373-5.6494-5.1943-9.3526-10.9756-9.3526a11.12817,11.12817,0,0,0-7.9834,3.252c-2.915,2.9805-3.2431,6.1621-3.2431,15.8398,0,9.6748.3281,12.8575,3.2431,15.8379a11.12633,11.12633,0,0,0,7.9834,3.2451c5.7813,0,9.8672-3.6943,11.1065-9.3466h4.9336C194.79437,61.7366,188.50047,66.8021,180.24947,66.8021Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.312,47.3177V66.4066h-4.9394V47.3177L216.61277,20.178h5.3203l10.9082,22.1377,10.7783-22.1377h5.3252Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36767,66.4066h-17.9854V20.178h17.3965c8.0527,0,13.6387,4.6153,13.6387,12.3399a10.59765,10.59765,0,0,1-6.8213,10.1289,11.18412,11.18412,0,0,1,7.5352,10.9746C304.13137,61.9915,298.55227,66.4066,290.36767,66.4066Zm-.96878-41.8096H277.314V40.6331h12.08492c5.12108,0,9.084-2.5283,9.084-8.0566C298.48289,27.0618,294.52,24.597,289.39889,24.597Zm.50878,20.4502H277.314V61.9915h12.5937c5.7129,0,9.2891-3.3076,9.2891-8.5039C299.19677,48.2972,295.62057,45.0472,289.90767,45.0472Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.98389,66.4066V20.178h28.69728v4.419h-23.7627V40.8919h20.2578v4.415h-20.2578V61.9915h23.7627v4.4151Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.72607,66.4066,403.20647,45.89H392.105V66.4066h-4.9336V20.178H404.894c8.0586,0,13.6983,4.8731,13.6983,12.8575,0,6.7519-4.0859,11.1699-10.0566,12.4023l10.9697,20.9688ZM404.439,24.597H392.105V41.5413h12.334c5.3906,0,9.2226-2.792,9.2226-8.4404C413.66157,27.4554,409.82957,24.597,404.439,24.597Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.37059,66.4066V47.0638h-15.6562V66.4066h-9.0176V20.178h9.0176V39.0745h15.6562V20.178h9.0195V66.4066Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.69869,66.4066l-2.7265-8.1748h-16.4258l-2.79,8.1748h-9.4151l16.8164-46.2286h7.0694l16.8857,46.2286Zm-10.7783-32.5909-5.8457,16.8164h11.4942Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.70749,66.4066h-7.5312l-8.5049-28.0459-8.501,28.0459h-7.54L556.29829,20.178h9.4161l7.1416,29.1563,8.4355-29.1563h6.7598l8.4424,29.1563,7.2041-29.1563h9.415Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.99949,66.4066l-11.8808-21.0352-5.9737,7.1465V66.4066h-9.0254V20.178h9.0254V40.305l16.2949-20.127h10.9678l-15.3203,18.376L672.521,66.4066Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.14989,46.931V66.0189H85.20847V46.931L71.44867,19.7923H76.769L87.67727,41.93l10.7792-22.1377h5.3272Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.07668,66.0189H13.09328V19.7923h17.3945c8.05469,0,13.64259,4.6104,13.64259,12.3359a10.60729,10.60729,0,0,1-6.8233,10.1328,11.18329,11.18329,0,0,1,7.5371,10.9698C44.84417,61.6048,39.26117,66.0189,31.07668,66.0189Zm-.96879-41.8086h-12.083V40.2464h12.083c5.125,0,9.08688-2.5303,9.08688-8.0557C39.19477,26.6761,35.23289,24.2103,30.10789,24.2103Zm.51269,20.4472H18.02489V61.6048H30.62058c5.71089,0,9.28909-3.3105,9.28909-8.5068C39.90967,47.9085,36.33147,44.6575,30.62058,44.6575Z",
    transform: "translate(-13.09328 -19.7923)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberhawkTextBottom);
export default __webpack_public_path__ + "static/media/cyberhawk-text-bottom.a9248d6c68e9a703814fff094613702d.svg";
export { ForwardRef as ReactComponent };